var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVml1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c9c9c9;\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m3.04,9.46h0c-.18-.14-.41-.21-.65-.19-.24.03-.46.14-.6.32-.14.18-.21.4-.18.63.03.23.14.43.32.58l4.02,4.26-3.92,4.26c-.34.33-.35.87-.03,1.21.16.18.4.28.65.28.23,0,.45-.09.61-.24l4.98-5.55-5.19-5.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.02 18.35 10.99 9.36 10.95 9.27 9.11 9.27 9.11 20.81 10.89 20.81 10.89 12.96 14.36 20.73 14.4 20.81 15.63 20.81 19.12 12.98 19.12 20.81 20.9 20.81 20.9 9.27 19.08 9.27 15.02 18.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.89 19.31 24.89 9.19 23.11 9.19 23.11 20.81 28.86 20.81 28.86 19.31 24.89 19.31"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVml1);
export default __webpack_public_path__ + "static/media/vml-1.e591f325d809eb84f18c83c1717fee6a.svg";
export { ForwardRef as ReactComponent };